import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ordenesApi } from '../services/api';
import OrdenForm from '../components/OrdenForm';

const OrdenEditar = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [orden, setOrden] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadOrden();
  }, [id]);

  const loadOrden = async () => {
    try {
      const data = await ordenesApi.getById(id);
      setOrden(data);
    } catch (err) {
      setError('No se pudo cargar la orden');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (data) => {
    setSaving(true);
    setError('');
    try {
      await ordenesApi.update(id, data);
      alert('Orden actualizada exitosamente');
      navigate(`/ordenes/${id}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al actualizar la orden');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Editar Orden #{orden?.numero_orden}</h1>
          <p className="page-subtitle">Modifique los datos de la orden</p>
        </div>
      </div>

      {error && (
        <div className="alert alert-error">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
          {error}
        </div>
      )}

      <div className="card">
        <OrdenForm initialData={orden} onSubmit={handleSubmit} loading={saving} />
      </div>
    </div>
  );
};

export default OrdenEditar;
